import { Icon } from "~/components/base/Icon";
import { useToastStore } from "~/stores/toastStore";

export function AppToast() {
  const current = useToastStore((s) => s.current);
  if (!current) return null;

  return (
    <div className="toast" role="status" aria-live="polite">
      <Icon name="check" size={14} /> {current}
    </div>
  );
}
